import type { NewsItem } from "../types/comic";

export const newsCategories: string[] = ["全部", "新番速递", "行业资讯", "活动公告", "作者访谈"];

export const newsList: NewsItem[] = [
  {
    id: "summer-festival-2026",
    title: "蛙漫夏季动漫祭圆满落幕，三天吸引超十二万观众到场",
    summary:
      "为期三天的蛙漫夏季动漫祭在滨江会展中心收官，现场汇聚了百余位漫画作者、数十家周边展商，以及两天连场的新番发布会。",
    category: "活动公告",
    date: "2026-10-12",
    source: "蛙漫编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20colorful%20convention%20hall%20with%20cosplay%20fans%20and%20big%20stage%20lights%2C%20festive%20atmosphere%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-festival&orientation=landscape",
    views: "8.4万",
    content: [
      {
        type: "paragraph",
        text: "10 月 10 日至 12 日，为期三天的蛙漫夏季动漫祭在滨江会展中心顺利收官。据主办方统计，三天累计入场观众超过十二万人次，创下该活动历届新高。",
      },
      {
        type: "heading",
        text: "百余位作者现场签绘",
      },
      {
        type: "paragraph",
        text: "本届动漫祭共邀请到 108 位漫画作者与插画师现场签绘，其中《剑影江湖》作者白无咎与《星海彼端的约定》作者林川的联合签绘区，从开展前两小时就排起了长队。不少读者带着自己收藏的单行本，只为换一句亲笔的「感谢追更」。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20busy%20artist%20signing%20session%20table%20with%20fans%20holding%20books%2C%20warm%20hall%20lighting%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-festival-2&orientation=landscape",
      },
      {
        type: "heading",
        text: "新番发布会亮点回顾",
      },
      {
        type: "paragraph",
        text: "在主舞台的新番发布会上，多部待播动画公布了最新预告。由蛙漫独家连载作品改编的同名动画确认将于明年春季上线，首支正式 PV 在现场放映后引发全场欢呼。此外，主办方还宣布将启动「新人作者扶持计划」，为入围作者提供为期一年的连载资源支持。",
      },
      {
        type: "paragraph",
        text: "活动最后一天傍晚，全场观众一起点亮了随票附赠的绿色手环，为本次动漫祭画上了温柔的句点。下一届蛙漫动漫祭预计将于明年暑期与大家再见。",
      },
    ],
  },
  {
    id: "new-anime-spring",
    title: "《星海彼端的约定》动画化确认，首支预告片公开",
    summary:
      "蛙漫人气科幻漫画《星海彼端的约定》今日正式宣布动画化，官方同步释出首支预告片与主视觉图，预计明年春季开播。",
    category: "新番速递",
    date: "2026-10-10",
    source: "蛙漫动画情报站",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20new%20anime%20series%20poster%20style%20scene%20with%20a%20hero%20and%20a%20magical%20glowing%20sky%2C%20cinematic%20composition%2C%20modern%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-anime&orientation=landscape",
    views: "12.1万",
    content: [
      {
        type: "paragraph",
        text: "今天上午十点，蛙漫官方正式宣布，旗下人气科幻漫画《星海彼端的约定》将启动动画化制作，并公开了首支约 90 秒的预告片。预告中，木星环带与补给站的场景以三维技术呈现，配乐由曾参与多部热门剧集的新锐作曲家操刀。",
      },
      {
        type: "heading",
        text: "主创阵容",
      },
      {
        type: "paragraph",
        text: "原作漫画自 2026 年 6 月开更以来，凭借扎实的科幻设定与细腻的情感描写，迅速登上蛙漫人气榜前列，目前累计阅读量已突破 1280 万。制作方表示，动画将忠实还原漫画的时间线，并在太空场景的视觉表现上进行升级。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20space%20station%20window%20scene%20with%20a%20teal%20nebula%20and%20two%20silhouettes%2C%20cinematic%20mood%2C%20modern%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-anime-2&orientation=landscape",
      },
      {
        type: "paragraph",
        text: "预告片上线两小时内，相关话题便登上多个社交平台热榜。不少读者留言表示「终于等到这一天」。官方透露，完整配音阵容与开播日期将于下月进一步公开。",
      },
    ],
  },
  {
    id: "comic-award-2026",
    title: "蛙漫年度漫画大奖揭晓，《剑影江湖》摘得最佳长篇",
    summary:
      "2026 蛙漫年度漫画大奖公布结果，共颁出十项大奖。《剑影江湖》获得「年度最佳长篇」，新人作品也表现亮眼。",
    category: "行业资讯",
    date: "2026-10-06",
    source: "蛙漫编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20an%20award%20ceremony%20stage%20with%20a%20golden%20trophy%20and%20confetti%20for%20a%20comic%20competition%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20warm%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-award&orientation=landscape",
    views: "6.7万",
    content: [
      {
        type: "paragraph",
        text: "10 月 5 日晚，2026 蛙漫年度漫画大奖颁奖典礼在线举行。本届大奖共设十个奖项，从年度最佳长篇、最佳短篇，到最佳画风、最佳新人，涵盖创作与运营多个维度。",
      },
      {
        type: "heading",
        text: "年度最佳长篇：剑影江湖",
      },
      {
        type: "paragraph",
        text: "由白无咎创作的武侠漫画《剑影江湖》凭借扎实的叙事节奏与教科书级别的动作分镜，摘得「年度最佳长篇」。该作品已于 9 月完结，全二十话累计阅读量超 1536 万，是今年蛙漫平台上完结作品中口碑最高的一部。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20golden%20trophy%20on%20a%20spotlight%20stage%20with%20red%20curtains%20and%20confetti%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20warm%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-award-2&orientation=landscape",
      },
      {
        type: "paragraph",
        text: "值得一提的是，本届「最佳新人」由一部仅更新到第 12 话的校园题材作品获得，评审团认为其在情感刻画上展现出了超越经验的成熟度。完整获奖名单已在站内专题页同步公布。",
      },
    ],
  },
  {
    id: "voice-actor-interview",
    title: "声优访谈：如何用声音演出一个「不说话的冬天」",
    summary:
      "新番《末日拾荒者》主役声优接受蛙漫专访，聊了聊在安静场景中表演的难点，以及她与角色阿刃之间的共鸣。",
    category: "作者访谈",
    date: "2026-10-02",
    source: "蛙漫访谈栏目",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20voice%20actors%20recording%20in%20a%20bright%20studio%20with%20microphones%20and%20headphones%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-voice&orientation=landscape",
    views: "5.2万",
    content: [
      {
        type: "paragraph",
        text: "在《末日拾荒者》中，主角阿刃的大部分台词都很短，甚至有几集几乎没有对白。如何让「沉默」也充满情绪，成为本次专访的核心话题。",
      },
      {
        type: "heading",
        text: "把呼吸当成台词",
      },
      {
        type: "paragraph",
        text: "声优在采访中提到，为了演出荒原上的疲惫感，她会在录音前刻意做几组深呼吸，让嗓音带上一点沙哑。「观众听到的不只是话，还有他走了多远。」她说，最难的一场戏是角色第一次听到收音机里传来人声的瞬间，那一声「喂」她录了十七遍。",
      },
      {
        type: "paragraph",
        text: "访谈最后，她也向一直追更漫画的读者表达了感谢，并透露动画将保留原作中许多安静的长镜头，希望观众能戴上耳机，认真听完那些没有台词的段落。",
      },
    ],
  },
  {
    id: "creator-support-plan",
    title: "蛙漫启动新人作者扶持计划，入选者可获一年连载资源",
    summary:
      "面向首次投稿的新人作者，蛙漫推出为期一年的扶持计划，提供编辑一对一指导、首页推荐位与稿费保底等支持。",
    category: "行业资讯",
    date: "2026-09-28",
    source: "蛙漫编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20a%20comic%20artist%20drawing%20at%20a%20digital%20tablet%20in%20a%20cozy%20studio%20with%20sketches%20on%20the%20wall%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20warm%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-artist&orientation=landscape",
    views: "4.9万",
    content: [
      {
        type: "paragraph",
        text: "为了让更多有想法的新人作者被看见，蛙漫正式启动「新人作者扶持计划」。即日起至年底，首次在蛙漫投稿连载的作者均可报名参与。",
      },
      {
        type: "heading",
        text: "三项核心支持",
      },
      {
        type: "paragraph",
        text: "入选作者将获得三项支持：编辑一对一改稿指导、作品上线初期首页推荐位曝光，以及为期一年的稿费保底。平台希望通过这套机制，让作者能够更安心地把故事讲完，而不是被数据焦虑打断创作节奏。",
      },
      {
        type: "paragraph",
        text: "首批招募计划面向题材不限，鼓励校园、治愈、科幻与现实主义等多元方向投稿。报名入口已在蛙漫创作中心开放。",
      },
    ],
  },
  {
    id: "summer-fireworks-event",
    title: "夏日烟火主题线上活动开启，参与即有机会获得限定周边",
    summary:
      "蛙漫推出「夏日烟火」主题线上活动，读者可通过阅读、收藏与评论积累积分，兑换限定书签、贴纸等周边好礼。",
    category: "活动公告",
    date: "2026-09-22",
    source: "蛙漫运营中心",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20news%20banner%20illustration%20of%20summer%20festival%20fireworks%20over%20a%20river%20with%20lanterns%20and%20a%20happy%20crowd%2C%20modern%20flat%20anime%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=800&height=450&seq=waman-news-fireworks&orientation=landscape",
    views: "7.3万",
    content: [
      {
        type: "paragraph",
        text: "夏末的最后一场烟火，我们想和你一起看。蛙漫「夏日烟火」主题线上活动正式开启，活动持续至 10 月中旬。",
      },
      {
        type: "heading",
        text: "如何参与",
      },
      {
        type: "paragraph",
        text: "活动期间，读者在站内阅读章节、收藏作品与发表评论均可积累「蛙币」积分。积分可在活动专区兑换限定书签、透卡与贴纸套装等周边，数量有限，兑完即止。",
      },
      {
        type: "paragraph",
        text: "此外，活动期间每位读者还可以为最喜欢的作品点亮一次「烟火」，最终烟火数最高的作品将获得额外的首页专题推荐。快去为你追更的漫画点亮一束烟火吧。",
      },
    ],
  },
];